<template>
<div style="text-align:center" class="alert alert-danger">
    <h2>{{ titulo }}</h2>
    <h3>{{ rotaOrigem }}</h3>
</div>
</template>

<script>
export default {
  data () {
    return {
      titulo: 'Página não encontrada!',
      rotaOrigem: null
    }
  },
  // método executado assim que entra na rota.
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // recupera a página que está tentando acessar
      vm.rotaOrigem = to.fullPath
    })
  }
}
</script>

<style>
</style>
